"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _I18n = _interopRequireDefault(require("I18n"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _generalStore = require("general-store");

var _FormattedHTMLMessage = _interopRequireDefault(require("I18n/components/FormattedHTMLMessage"));

var _ImmutableModel = require("customer-data-objects/model/ImmutableModel");

var _ObjectTypes = require("customer-data-objects/constants/ObjectTypes");

var _links = require("crm_internal/config/links");

var _timelineTitleHelper = require("crm_ui/timeline/helpers/timelineTitleHelper");

var _LoadingStatus = require("crm_data/flux/LoadingStatus");

var _getExternalPropertyDependency = _interopRequireDefault(require("crm_ui/dependencies/getExternalPropertyDependency"));

var _getFormattedSourceLabel = _interopRequireDefault(require("crm_ui/property/history/getFormattedSourceLabel"));

var _reactImmutableProptypes = _interopRequireDefault(require("react-immutable-proptypes"));

var _ObjectTypesType = _interopRequireDefault(require("customer-data-objects-ui-components/propTypes/ObjectTypesType"));

var _PropertiesStore = _interopRequireDefault(require("crm_data/properties/PropertiesStore"));

var _SubjectType = _interopRequireDefault(require("customer-data-objects-ui-components/propTypes/SubjectType"));

var _TicketFormStore = _interopRequireDefault(require("crm_data/forms/supportForms/TicketFormStore"));

var _TimelineBody = _interopRequireDefault(require("crm_ui/timeline/components/generic/TimelineBody"));

var _TimelineHeader = _interopRequireDefault(require("crm_ui/timeline/components/generic/header/TimelineHeader"));

var _TimelineTeamsFilterDependency = _interopRequireDefault(require("crm_ui/timeline/data/dependencies/TimelineTeamsFilterDependency"));

var _TimelineTextFilterDependency = _interopRequireDefault(require("crm_ui/timeline/data/dependencies/TimelineTextFilterDependency"));

var _TimelineUsersFilterDependency = _interopRequireDefault(require("crm_ui/timeline/data/dependencies/TimelineUsersFilterDependency"));

var getStringToDisplay = {
  CONTACT: 'Contact',
  COMPANY: 'Company',
  DEAL: 'Deal',
  TICKET: 'Ticket'
};

var fromFacebookMessenger = function fromFacebookMessenger(subject) {
  return (0, _ImmutableModel.getProperty)(subject, 'hs_analytics_source_data_1') === 'SOCIAL' && (0, _ImmutableModel.getProperty)(subject, 'hs_analytics_source_data_2') === 'FacebookMessenger';
};

var createdSourceInfoDep = _getExternalPropertyDependency.default.single('hs_analytics_source_data_1');

var USER_TEXT_BASE_KEY = 'profileContentTimeline.timelineCreateSourceEvent.bodyText';
var propTypes = {
  subject: _SubjectType.default,
  objectType: _ObjectTypesType.default.isRequired,
  formattedAnalyticsSource: _propTypes.default.string,
  createdSourceInfo: _propTypes.default.string,
  icon: _propTypes.default.string.isRequired,
  ticketForm: _reactImmutableProptypes.default.map,
  timelineItem: _propTypes.default.object.isRequired,
  searchText: _propTypes.default.string.isRequired,
  selectedTeams: _reactImmutableProptypes.default.list.isRequired,
  selectedUsers: _reactImmutableProptypes.default.list.isRequired
};
var dependencies = {
  createdSourceInfo: {
    stores: [],
    deref: function deref(_ref) {
      var subject = _ref.subject;

      if (!subject) {
        return null;
      }

      var createdSourceInfo = (0, _ImmutableModel.getProperty)(subject, 'hs_analytics_source_data_1');

      if (createdSourceInfo) {
        return createdSourceInfoDep.deref({
          value: createdSourceInfo
        }) || createdSourceInfo;
      }

      return null;
    }
  },
  formattedAnalyticsSource: {
    stores: [_PropertiesStore.default],
    deref: function deref(_ref2) {
      var objectType = _ref2.objectType,
          subject = _ref2.subject;
      if (!subject || objectType !== _ObjectTypes.CONTACT) return null;
      var analyticsSource = (0, _ImmutableModel.getProperty)(subject, 'hs_analytics_source');

      var properties = _PropertiesStore.default.get(objectType);

      var property = properties && properties.get('hs_analytics_source');
      if (!property) return null;
      var option = property.options.find(function (opt) {
        return opt.get('value') === analyticsSource;
      });

      if (option) {
        return option.get('label') || analyticsSource;
      }

      return null;
    }
  },
  selectedTeams: _TimelineTeamsFilterDependency.default,
  selectedUsers: _TimelineUsersFilterDependency.default,
  searchText: _TimelineTextFilterDependency.default,
  ticketForm: {
    stores: [_TicketFormStore.default],
    deref: function deref() {
      var ticketForms = _TicketFormStore.default.get();

      if ((0, _LoadingStatus.isLoading)(ticketForms)) {
        return _LoadingStatus.LOADING;
      }

      if (!ticketForms || !ticketForms.size) {
        return _LoadingStatus.EMPTY;
      }

      return ticketForms.first();
    }
  }
};

var TimelineCreateSourceEvent =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(TimelineCreateSourceEvent, _Component);

  function TimelineCreateSourceEvent() {
    (0, _classCallCheck2.default)(this, TimelineCreateSourceEvent);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(TimelineCreateSourceEvent).apply(this, arguments));
  }

  (0, _createClass2.default)(TimelineCreateSourceEvent, [{
    key: "getBodyText",
    value: function getBodyText() {
      var createdSource;
      var createdSourceInfo = this.props.createdSourceInfo;
      var _this$props = this.props,
          subject = _this$props.subject,
          formattedAnalyticsSource = _this$props.formattedAnalyticsSource,
          ticketForm = _this$props.ticketForm;
      var objectType = (0, _ImmutableModel.getObjectType)(subject);
      if (!subject) return null;
      var contactName = (0, _ImmutableModel.toString)(subject);

      if (objectType === _ObjectTypes.CONTACT) {
        var analyticsSource = (0, _ImmutableModel.getProperty)(subject, 'hs_analytics_source');

        if (analyticsSource) {
          if (analyticsSource === 'OFFLINE') {
            createdSourceInfo = undefined;
          }

          createdSource = formattedAnalyticsSource; // TODO @nhwang: replace with shared source label maker

          if (fromFacebookMessenger(subject)) {
            createdSourceInfo = _I18n.default.text('properties.labels.sources.facebookMessenger');
          }
        }
      }

      if (!createdSource) {
        var createdBy = subject.getIn(['properties', 'created_by']);

        if (createdBy) {
          var source = createdBy.get('source');
          var sourceId = createdBy.get('sourceId');
          createdSource = (0, _getFormattedSourceLabel.default)({
            source: source,
            sourceId: sourceId
          });

          if (source === 'FORM' && ticketForm) {
            var returnUrl = (0, _links.fromObjectTypeAndId)(objectType, (0, _ImmutableModel.getId)(subject)); //link the support form for tickets only since we don't have access to any info as to what specific form created the object

            var createdSourceLink = (0, _links.formEditor)(ticketForm.get('id'), returnUrl);
            return _react.default.createElement(_FormattedHTMLMessage.default, {
              message: USER_TEXT_BASE_KEY + ".eventTextCreatedByLink",
              options: {
                contactName: contactName,
                createdSource: createdSource,
                createdSourceLink: createdSourceLink
              }
            });
          }

          return _react.default.createElement(_FormattedHTMLMessage.default, {
            message: USER_TEXT_BASE_KEY + ".eventTextCreatedBy",
            options: {
              contactName: contactName,
              createdSource: createdSource
            }
          });
        }
      }

      if (createdSource) {
        if (createdSourceInfo) {
          return _react.default.createElement(_FormattedHTMLMessage.default, {
            message: USER_TEXT_BASE_KEY + ".eventTextWithInfo",
            options: {
              contactName: contactName,
              createdSource: createdSource,
              createdSourceInfo: createdSourceInfo
            }
          });
        }

        return _react.default.createElement(_FormattedHTMLMessage.default, {
          message: USER_TEXT_BASE_KEY + ".eventText",
          options: {
            contactName: contactName,
            createdSource: createdSource
          }
        });
      }

      return _react.default.createElement(_FormattedHTMLMessage.default, {
        message: USER_TEXT_BASE_KEY + ".noSource",
        options: {
          contactName: contactName
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          icon = _this$props2.icon,
          objectType = _this$props2.objectType,
          searchText = _this$props2.searchText,
          selectedTeams = _this$props2.selectedTeams,
          selectedUsers = _this$props2.selectedUsers,
          subject = _this$props2.subject;
      var typeTitle = (0, _timelineTitleHelper.getTimelineItemTitle)(this.props.timelineItem);
      var createDate = (0, _ImmutableModel.getProperty)(this.props.subject, 'createdate');

      if (!subject) {
        return null;
      }

      if (searchText.length || selectedTeams.size || selectedUsers.size) {
        return null;
      }

      return _react.default.createElement("div", null, _react.default.createElement(_TimelineHeader.default, {
        typeTitle: typeTitle,
        timestamp: +createDate,
        icon: icon,
        titleOptions: {
          objectType: getStringToDisplay[objectType]
        }
      }), _react.default.createElement(_TimelineBody.default, null, this.getBodyText()));
    }
  }]);
  return TimelineCreateSourceEvent;
}(_react.Component);

TimelineCreateSourceEvent.propTypes = propTypes;

var _default = (0, _generalStore.connect)(dependencies)(TimelineCreateSourceEvent);

exports.default = _default;
module.exports = exports.default;